function initSwiperBest() {
  // Only initialize Swiper for screens <= 1024px (tablets and mobile)
  if (window.innerWidth <= 1024) {
    var swiperBest = new Swiper(".swiper-best", {
      loop: true,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 24,

      breakpoints: {
        768: {
          slidesPerView: "auto",
          slidesPerGroup: 1,
          spaceBetween: 24,
        },

        1025: {
          slidesPerView: "auto",
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
      },

      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true,
      //   },

      //   navigation: {
      //     nextEl: ".swiper-next",
      //     prevEl: ".swiper-prev",
      //   },
    });
  }
}

// Run the function initially on page load
initSwiperBest();

// Optionally, listen for window resize events to destroy or re-initialize Swiper when resizing
window.addEventListener("resize", function () {
  // Remove existing Swiper instance if any on larger screens
  var swiperInstance = document.querySelector(".swiper-best").swiperBest;
  if (swiperInstance && window.innerWidth > 1024) {
    swiperInstance.destroy(true, true); // destroy swiper on larger screens
  } else if (!swiperInstance && window.innerWidth <= 1024) {
    initSwiperBest(); // re-initialize swiper if resized back to <= 1024px
  }
});
